import { render, staticRenderFns } from "./AccountSettingMailTemplates.vue?vue&type=template&id=968a5172&"
import script from "./AccountSettingMailTemplates.vue?vue&type=script&lang=js&"
export * from "./AccountSettingMailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingMailTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports